export const PROGRESS_BAR_STEPS = [
  {id: 'signup', label: 'Sign Up'},
  {id: 'setup', label: 'Setup'},
  {id: 'integration', label: 'Integration Status'}
];

export default PROGRESS_BAR_STEPS;
